import React from 'react'
import { useTranslation } from 'translations'
import { Section } from '../components/section'
import { ComboboxFieldFormik } from 'uiComponents/combobox/comboboxFieldFormik'
import { ResellerResponseItem } from 'settings/settingsService'

interface ResellerSectionProps {
    resellerFieldDisabled: boolean
    resellersList: ResellerResponseItem[]
    loadingResellers: boolean
    errorMessage: string
}

export const ResellerSection = ({
    resellerFieldDisabled,
    resellersList,
    loadingResellers,
    errorMessage,
}: ResellerSectionProps) => {
    const { t } = useTranslation()

    return (
        <Section title={t('settings.users.form.sections.reseller')} className="reseller">
            <div className="row">
                <ComboboxFieldFormik
                    id="resellerId"
                    className="resellerId"
                    options={resellersList.map((reseller) => ({
                        label: reseller.name,
                        value: reseller.resellerId,
                    }))}
                    disabled={resellerFieldDisabled}
                    loading={loadingResellers}
                    error={errorMessage}
                />
            </div>
        </Section>
    )
}
